/**
 * @fileoverview Rotate-device overlay component.
 * Shown by CSS on phones in landscape mode; no JS interaction needed.
 */

import { render } from 'preact';

function RotateOverlay() {
    return (
        <div class="rotate-content">
            <div class="rotate-icon">📱</div>
            <p>Please rotate your device to portrait mode</p>
        </div>
    );
}

export function mountRotateOverlay(): void {
    const el = document.getElementById('rotateOverlay');
    if (!el) return;
    render(<RotateOverlay />, el);
}
